export default __webpack_public_path__ + "static/media/lotus.c0a65a71.svg";